/**
 * SSO provider types
 */
const SSO_PROVIDER_TYPE = {
    microsoft: 'microsoft_tenant',
    google: 'google'
};

/**
 * SSO provider button styles
 */
const SSO_PROVIDER_BUTTON_STYLES = {
    [SSO_PROVIDER_TYPE.microsoft]: {
        label: 'Microsoft',
        icon: require('@assets/microsoft.svg')
    },
    [SSO_PROVIDER_TYPE.google]: {
        label: 'Google',
        icon: require('@assets/google.svg')
    }
};

export { SSO_PROVIDER_TYPE, SSO_PROVIDER_BUTTON_STYLES };
